import { Outlet } from 'react-router-dom'

const DemoLayout = () => {
    return (
        <div className="relative bg-black overflow-hidden min-h-screen w-full flex flex-col">
            
            <main className="flex-1">
                <Outlet />
            </main>
            
        </div>
    )
}

export default DemoLayout